import * as React from 'react'

import useHasMounted from 'app/hooks/use-has-mounted'

const ClientOnly: React.FC<React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>> = ({ children }) => {
  const hasMounted = useHasMounted()

  if (!hasMounted) {
    return null
  }

  return <>{children}</>
}

export default ClientOnly
